import * as React from 'react';

const DOTS = '...';
const range = (start, end) => Array.from({ length: end - start + 1 }, (_, idx) => idx + start);
const usePagination = (totalPageCount, currentPage) => {
    const siblingCount = 1;
    const totalPageNumbers = siblingCount * 2 + 5;
    return React.useMemo(() => {
        if (totalPageCount === 1) {
            return [];
        }
        if (totalPageCount <= totalPageNumbers) {
            return range(1, totalPageCount);
        }
        const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPageCount - 1;
        const firstPage = 1;
        const lastPage = totalPageCount;
        if (!shouldShowLeftDots && shouldShowRightDots) {
            // Слева всё видно, справа — ...
            const leftRange = range(1, 3 + siblingCount * 2);
            return [...leftRange, DOTS, lastPage];
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            // Справа всё видно, слева — ...
            const rightRange = range(totalPageCount - (2 + siblingCount * 2), totalPageCount);
            return [firstPage, DOTS, ...rightRange];
        }
        if (shouldShowLeftDots && shouldShowRightDots) {
            // И слева и справа есть ...
            const middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [firstPage, DOTS, ...middleRange, DOTS, lastPage];
        }
        return range(1, totalPageCount);
    }, [totalPageCount, totalPageNumbers, currentPage]);
};

export { usePagination };
//# sourceMappingURL=usePagination.js.map
